import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RemoveTeamsTabPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-removeteamstabpage" */ "./RemoveTeamsTabPage")).then((bundle)=>{
        return {
            default: bundle.RemoveTeamsTabPage
        };
    });
export const LazyRemoveTeamsTabPage = /*#__PURE__*/ lazy(RemoveTeamsTabPageLazyLoader);
